import script from "./ProjectDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetailView.vue?vue&type=style&index=0&id=28b2b0da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b2b0da"]])

export default __exports__